import React from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';
import { getDpiaBadgeClass, getDpiaLabel } from '../apaDpiaStatus.helpers';

type ApaDpiaStatusBadgeProps = {
  className?: string;
  status: string;
};

const ApaDpiaStatusBadge: React.FC<ApaDpiaStatusBadgeProps> = ({ className, status }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!status) {
    return null;
  }

  return <span className={clsx(styles.dpiaBadge, getDpiaBadgeClass(status, styles), className)}>{getDpiaLabel(status, t)}</span>;
};

export default ApaDpiaStatusBadge;
